"use client"

import { useState } from 'react'
import { useInputValueStore } from './InputValueStoreProvider'
import Modal from '@components/modal/Modal'
import { PartCategoryPicker } from '@components/form/app-input/PartCategoryPicker'
import { BasicInput } from './BasicInput'
import { HintInputIcon } from './HintInputIcon'
import { setHtmlValue } from './utils/setHtmlValue'
import useT from '@hooks/useTranslation'

import iconStyles from './Hint.module.css'
import styles from './InputWithPartCategoryPicker.module.css'

export function InputWithPartCategoryPicker ( {
    disabled,
    hint,
    label,
    pickerProps,
    solid,
    t,
    tooltip,

    ...props
}) {
    const [showPicker, setShowPicker] = useState(false)
    const [hasValue, setHasValue] = useState(false)

    const { getValue, getValues, hasValues, setValue } = useInputValueStore()

    const { name } = props
    const { deps } = hint
    const hasDeps = deps ? hasValues(deps) : true
    const depValues = deps ? getValues(deps) : []

    disabled = disabled || !hasDeps

    const togglePicker = disabled
        ? undefined
        : () => setShowPicker(show => !show)

    const onPickerChange = (value) => {
        if (value !== null) {
            setValue(name, value)
            setHtmlValue(name, value)
            setHasValue(Boolean(value))
        }
        setShowPicker(false)
    }

    const clear = () => onPickerChange('')

    const _label = t || label
    const labelTranslated = useT(_label)

    const value = getValue(name)

    return  <>
        <div className={styles[disabled ? 'disabled' : 'on'] + ' ' + styles.pad}>
            <HintInputIcon action={clear} className={iconStyles['clear-icon']} icon={hasValue ? 'close' : ''}>
                <HintInputIcon className={iconStyles['toggle-icon']} icon={`expand_${showPicker ? 'less' : 'more'}`}>
                    <BasicInput
                        label={labelTranslated}
                        name={name}

                        {...props}

                        onClick={togglePicker}
                    />
                </HintInputIcon>
            </HintInputIcon>
        </div>

        <Modal open={showPicker} onClose={togglePicker} style={{height:800}}>
            <div style={{width:560,maxWidth:'100%'}} />
            <PartCategoryPicker
                defaultValue={value}
                deps={deps}
                depValues={depValues}
                onChange={onPickerChange}
                {...pickerProps}
            />
        </Modal>

    </>
}